import { FaSearch, FaCheck, FaClock } from "react-icons/fa";

export default function TablaPedidos({
  pedidos,
  loading,
  puedeGestionar,
  onSelectPedido,
  onCambiarEstado,
  onCancelarPedido,
  calcularTotalPedido,
}) {

  const formatCOP = (valor) =>
    Number(valor || 0).toLocaleString("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    });

  const calcularGananciaPedido = (pedido) => {
    if (!pedido.detalles) return 0;

    return pedido.detalles.reduce((total, d) => {
      return total + ((d.precioUnitario - d.costoUnitario) * d.cantidad);
    }, 0);
  };

  return (
    <>
      {/* ================= DESKTOP ================= */}
      <div className="hidden md:block overflow-x-auto rounded-xl
                      border border-slate-200 dark:border-slate-800
                      bg-white dark:bg-slate-900">
        <table className="w-full min-w-[950px] text-sm">
          <thead className="bg-slate-100 dark:bg-slate-950 dark:text-slate-200">
            <tr>
              <th className="px-4 py-2 text-left">ID</th>
              <th className="px-4 py-2 text-center">Mesero</th>
              <th className="px-4 py-2 text-center">Fecha</th>
              <th className="px-4 py-2 text-center">Descripción</th>
              <th className="px-4 py-2 text-center">Total</th>
              <th className="px-4 py-2 text-center">Ganancia</th>
              <th className="px-4 py-2 text-center">Estado</th>
              <th className="px-4 py-2 text-center">Facturado</th>
              <th className="px-4 py-2 text-center">Acciones</th>
            </tr>
          </thead>

          <tbody>
            {pedidos.length === 0 ? (
              <tr>
                <td colSpan="9" className="px-4 py-6 text-center">
                  {loading ? "Cargando pedidos..." : "No hay pedidos"}
                </td>
              </tr>
            ) : (
              pedidos.map((pedido) => {
                const ganancia = calcularGananciaPedido(pedido);

                return (
                  <tr key={pedido.id}
                      className="odd:bg-white even:bg-slate-50
                                 dark:odd:bg-slate-900 dark:even:bg-slate-800">

                    <td className="px-4 py-2">{pedido.id}</td>

                    <td className="px-4 py-2 text-center">
                      {pedido.mesero?.nombre || "—"}
                    </td>

                    <td className="px-4 py-2 text-center">
                      {new Date(pedido.fecha).toLocaleString()}
                    </td>

                    <td className="px-4 py-2 text-center">
                      {pedido.descripcion || "—"}
                    </td>

                    <td className="px-4 py-2 text-center font-semibold">
                      {formatCOP(calcularTotalPedido(pedido))}
                    </td>

                    <td className={`px-4 py-2 text-center font-semibold ${
                      ganancia >= 0 ? "text-emerald-600" : "text-rose-600"
                    }`}>
                      {formatCOP(ganancia)}
                    </td>

                    <td className="px-4 py-2 text-center">
                      <EstadoBadge entregado={pedido.entregado} />
                    </td>

                    <td className="px-4 py-2 text-center">
                      <FacturadoBadge facturado={pedido.facturado} />
                    </td>

                    <td className="px-4 py-2 text-center">
                      <Acciones
                        pedido={pedido}
                        puedeGestionar={puedeGestionar}
                        onSelectPedido={onSelectPedido}
                        onCambiarEstado={onCambiarEstado}
                        onCancelarPedido={onCancelarPedido}
                      />
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* ================= MOBILE ================= */}
      <div className="md:hidden space-y-4">
        {pedidos.map((pedido) => {
          const ganancia = calcularGananciaPedido(pedido);

          return (
            <div key={pedido.id}
                 className="rounded-2xl bg-white dark:bg-slate-800
                            border p-4 shadow-md text-sm">

              <div className="flex justify-between mb-2">
                <span className="font-semibold">
                  Pedido #{pedido.id}
                </span>

                <span className="font-bold text-emerald-600">
                  {formatCOP(calcularTotalPedido(pedido))}
                </span>
              </div>

              <div className="text-slate-600 space-y-1">
                <div><b>Mesero:</b> {pedido.mesero?.nombre || "—"}</div>
                <div><b>Fecha:</b> {new Date(pedido.fecha).toLocaleString()}</div>
                <div>
                  <b>Ganancia:</b>{" "}
                  <span className={ganancia >= 0 ? "text-emerald-600" : "text-rose-600"}>
                    {formatCOP(ganancia)}
                  </span>
                </div>
              </div>

              <div className="flex flex-wrap gap-2 mt-3">
                <EstadoBadge entregado={pedido.entregado} />
                <FacturadoBadge facturado={pedido.facturado} />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

/* ===== BADGES ===== */

const EstadoBadge = ({ entregado }) => (
  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
    entregado ? "bg-emerald-500/20 text-emerald-400"
              : "bg-amber-500/20 text-amber-400"
  }`}>
    {entregado ? "Entregado" : "Pendiente"}
  </span>
);

const FacturadoBadge = ({ facturado }) => (
  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
    facturado ? "bg-emerald-500/20 text-emerald-400"
              : "bg-rose-500/20 text-rose-400"
  }`}>
    {facturado ? "Facturado" : "No facturado"}
  </span>
);

const Acciones = ({
  pedido,
  puedeGestionar,
  onSelectPedido,
  onCambiarEstado,
  onCancelarPedido,
}) => (
  <div className="flex flex-wrap justify-center gap-2">
    <button
      onClick={() => onSelectPedido(pedido)}
      className="px-3 py-1.5 rounded-lg text-xs font-medium
                 border border-sky-500 text-sky-400">
      <FaSearch /> Ver
    </button>
  </div>
);